export default "__VITE_ASSET__Cf9cPaAF__"